import { heliosAPI } from 'utils/services/heliosAPI';
import { AuthContextImplementation } from './AuthContextType';

const AUTH_URL = '/helios-api/auth/login';
const RETURN_PATH_KEY = 'local_auth_return_path';

export const LocalAuthContext = (): AuthContextImplementation => {
    const goToLogin = (path = '/') => {
        // Store the return path in sessionStorage for after login
        sessionStorage.setItem(RETURN_PATH_KEY, path);
        window.location.href = '/login';
    };

    return {
        goToLogin,
        login: async (username: string, password: string) => {
            await heliosAPI.post(AUTH_URL, {
                login: username,
                password,
            });

            // Get the stored return path, default to /sites
            const returnPath =
                sessionStorage.getItem(RETURN_PATH_KEY) || '/sites';
            sessionStorage.removeItem(RETURN_PATH_KEY);

            // Navigate directly to the return path
            window.location.href = returnPath;
        },
        logout: async (isProxyUser: boolean, path?: string) => {
            await heliosAPI.delete(AUTH_URL);
            if (isProxyUser) {
                window.location.reload();
            } else {
                goToLogin(path);
            }
        },
    };
};
